module.exports = __webpack_public_path__ + "static/spot-e7faa6af924f2bbe30a8d4d4a4a758f0.png";